import { components } from './components';
import { constants } from './constants';
import { facialRecognition } from './facialRecognition';
import { helpers } from './helpers';
import { hooks } from './hooks';
import { testimonials } from './testimonials';
import { validations } from './validations';

export const sharedPt = {
  ...components,
  ...constants,
  ...facialRecognition,
  ...helpers,
  ...hooks,
  ...testimonials,
  ...validations,
};
